import { Typography } from '@material-ui/core';
import { FC } from 'react';

import useUserDashboardStyles from '../../hooks/styles/userDashboardStyles';
import { UserSession } from '../../_services/authentication.service';

type UserDrawerProps = {
  user: UserSession;
}

export const UserDrawer: FC<UserDrawerProps> = ({ user }) => {
  const classes = useUserDashboardStyles()

  return (
    <Typography className={classes.welcomeTitle}>
      Bienvenido, <span className={classes.usernameTitle}>{user.firstname}</span>
    </Typography>
  );
}
